export default __webpack_public_path__ + "static/media/defend.f1fef511.png";